import firebase from "firebase";
import {MaintenanceRequestStatus} from "@/enums/MaintenanceRequestStatus";
import { UserTypeEnum } from '@/enums/UserTypeEnum';
import { AuditLogsTier1 as Tier1, AuditLogsTier2 as Tier2, AuditLogsTier3 as Tier3 } from '@/enums/AuditLogs';

export default {
  name: "maintenanceRequestCancelDlg",
  data() {
    return {
      dialog: false,
      requestId: null,
      comment: "",
      loading: false
    }
  },
  methods: {
    open(requestId) {
      this.dialog = true;
      this.requestId = requestId;
    },
    close() {
      this.dialog = false;
      this.requestId = null;
      this.comment = "";
    },
    async submit() {
      this.loading = true;

      await firebase
        .firestore()
        .collection("maintenanceRequests")
        .doc(this.requestId)
        .update({
          status: MaintenanceRequestStatus.Cancelled,
          cancelReason: this.comment,
          cancelledDateTime: firebase.firestore.Timestamp.fromDate(new Date()),
          updatedById: this.$store.state.authModule.user.id,
          updatedByType: UserTypeEnum.Staff,
          typesOfRecordChanged: [`${Tier1.Maintenance}: ${Tier2.JobRequest}: ${Tier3.Amend}`]
        }).then(async () => {
          await this.$store.dispatch('getMaintenanceRequest', this.$route.params.id);

          this.$toast.open({
            type: "success",
            message: this.$t("MaintenanceView.RequestHasBeenSuccessfullyCanceled")
          })
          this.loading = false;
          this.close();
        })
    }
  }
}